module.exports = __webpack_public_path__ + "img/icon_tt_arr_down.0cdd1a7e.svg";